import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { StoreService } from '../store.service';
import { NgxSpinnerService } from 'ngx-spinner';
import './switchcompany.component.css';


@Component({
  selector: 'app-switchcompany',
  templateUrl: './switchcompany.component.html',
  //styleUrls: ['./switchcompany.component.css'],
  providers:[ApiService],
  encapsulation: ViewEncapsulation.None
})
export class SwitchcompanyComponent implements OnInit {

  companies:any = [];
  constructor(private api: ApiService, private router: Router,private ss:StoreService, private spinner: NgxSpinnerService ) { }

  ngOnInit() {
      this.bindCompanies();
  }

  
  bindCompanies() {
    this.api.get('Rah/GetByAccountID', '').subscribe(
      (res: {}) => this.sucessQboMaster(res),
      error => this.failedQboMaster(<any>error));
  }

  sucessQboMaster(res: any) {
    
    if (res.StatusCode == 0) {
      this.companies = res.Data;
    }

  }
  failedQboMaster(res: any) {

  }

  companySelected(company:any){

    console.log(company);
    this.ss.storeQboConnectID(company.RahID);
    this.ss.storeCompanyName(company.CompanyName);

    var token = this.ss.fetchToken();
    this.router.navigate(['/initlogin/'+token+'/'+company.RahID+'/connectcompany']);
  }

  addNewCompany(){
    var token = this.ss.fetchToken();
    window.location.href = this.api.qboConnectUrl+token;
  }

}
